import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/apiClient";
import { ShareSheet } from "@/components/ShareSheet";
import { READING_BY_SLUG } from "@/lib/readingsContent";

// Side tab (desktop) / floating pill (phone) that shares the running offer with the member's invite code.
export default function ShareOfferTab({ slug }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState(null);
  useEffect(() => {
    if (user && !user.is_demo) api.get("/referral").then(({ data }) => setCode(data.code)).catch(() => {});
  }, [user]);
  const r = READING_BY_SLUG[slug];
  const link = `${window.location.origin}/readings/${slug}${code ? `?ref=${code}` : ""}`;
  return (
    <>
      <button data-testid="share-offer-tab" onClick={() => setOpen(true)}
        className="fixed z-30 right-4 bottom-[calc(84px+env(safe-area-inset-bottom))] lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 lg:right-0 flex items-center gap-2 bg-[#D4AF37] hover:bg-[#e6c04e] text-[#04060B] font-medium text-sm px-4 py-2.5 rounded-full lg:rounded-r-none lg:rounded-l-2xl lg:px-3 lg:py-4 lg:[writing-mode:vertical-rl] shadow-[0_10px_30px_rgba(212,175,55,0.35)] transition-colors">
        <Gift size={16} className="lg:rotate-90" /> Send this offer to friends
      </button>
      <ShareSheet open={open} onClose={() => setOpen(false)} testId="share-offer-sheet"
        title={`A free ${r.title} from Astra`}
        desc={code ? "Friends who join through your link count towards your free Premium month (5 friends = 1 month)." : "Share this limited-time offer with friends."}
        text={`I found this: a free ${r.title} when you join Astra, for a limited time. ${r.short}`}
        link={link} />
    </>
  );
}
